<!-- alert-notification popup (on view button of alert) -->
<div class="popup-bg ">
    <div class="popup alert-notification">
        <div class="popup-content">
            <div class="popup-content-head">
                <h3>Alert Notification</h3>
                <div class="popup-head-links">
                    <a href="javscript:void(0)" class="btn btn-dark" (click)="forPopupOpen('','AddNewAlert')">Add new
                            alerts</a>
                    <!-- <app-add-new-alert *ngIf="cardType && (globalService.showPopUp==cardType['AddNewAlert'])"> -->
                    <!-- </app-add-new-alert>      ON PERFORMANCE PAGE   -->
                    <a href="javscript:void(0)" class="btn btn-dark" (click)="forPopupOpen('','viewAlert')">View Alerts</a>
                    <!-- <app-view-alerts *ngIf="cardType && (globalService.showPopUp==cardType['viewAlert'])">
                        </app-view-alerts>             ON PERFORMANCE PAGE       -->
                </div>
            </div>
            <ng-scrollbar>
                <div class="popup-tabling">
                    <table class="alert-table notification-alert">
                        <tr>
                            <th><span class="app-text">Name</span></th>
                            <th><span class="app-text">KPI</span></th>
                            <th><span class="app-text">Condition</span></th>
                            <th><span class="app-text">Value</span></th>
                            <th><span class="app-text">App</span></th>
                            <th><span class="app-text">Network</span></th>
                            <!-- <th><span class="app-text">Time</span></th> -->
                            <th><span class="app-text">Date</span></th>
                            <!-- <th><span class="app-text">City</span></th> -->
                            <!-- <th><span class="app-text">Test Run</span></th> -->
                        </tr>
                        <tr *ngFor="let alert of alertList;" [ngClass]="{'active':!alert['viewed']}">
                            <td><span class="app-text" (click)="forPopupOpen(alert,'editAlert')">{{alert['alertName']}}</span></td>
                            <td><span class="app-text">{{alert['scoreName']}}</span></td>
                            <td><span class="app-text">{{alert['scoreCondition']}}</span></td>
                            <td><span class="app-text">{{alert['value']}}</span></td>
                            <td><span class="app-text">{{alert['appname']}}</span></td>
                            <td><span class="app-text network-operator">{{alert['operator']}}</span></td>
                            <!-- <td><span class="app-text">{{alert['updatedtime']}}</span></td> -->
                            <td><span class="app-text">{{alert['startDate'] + '&nbsp;to&nbsp;' +alert['endDate']}}</span></td>
                            <!-- <td><span class="app-text">{{alert['location']}}</span></td> -->
                            <!-- <td><a href="javascript:void(0)" class="link-medium">View</a></td> -->
                        </tr>


                    </table>
                    <div class="no-data" *ngIf="alertList.length==0">
                        <span>No Data found.</span>
                    </div>
                </div>
            </ng-scrollbar>
            <div class="popup-links text-right">
                <a href="javscript:void(0)" class="btn btn-light" (click)="forPopupClose()">close</a>
            </div>
        </div>
    </div>
</div>